import { Box, Chip, CircularProgress, LinearProgress, Stack, Typography } from "@mui/material";
import { computeSyncProgress, formatSyncProgress } from "../../../../utils/keyword-sync-progress";

interface KeywordSyncStatusProps {
  pendingKeywords: number;
  syncingKeywords: number;
  noResultKeywords: number;
  failedKeywords?: number;
  totalKeywords?: number;
}

export const KeywordSyncStatus = ({
  syncingKeywords,
  noResultKeywords,
  failedKeywords = 0,
  totalKeywords,
}: KeywordSyncStatusProps) => {
  const syncing = syncingKeywords > 0;
  const progress =
    syncing && totalKeywords !== undefined
      ? computeSyncProgress(totalKeywords, syncingKeywords)
      : null;

  return (
    <Stack spacing={0.5} alignItems="flex-start" sx={{ minWidth: 150 }}>
      <Stack direction="row" spacing={0.75} alignItems="center">
        {syncing && <CircularProgress size={14} thickness={5} />}
        <Typography variant="body2" color={syncing ? "primary" : "text.secondary"}>
          {syncing ? "Sincronizando…" : "Atualizado"}
        </Typography>
      </Stack>
      {syncing &&
        (progress ? (
          <Box sx={{ width: "100%" }}>
            <LinearProgress
              variant="determinate"
              value={progress.pct}
              sx={{ height: 6, borderRadius: 3, mb: 0.25 }}
            />
            <Typography variant="caption" color="text.secondary">
              {formatSyncProgress(progress)}
            </Typography>
          </Box>
        ) : (
          <Typography variant="caption" color="text.secondary">
            {syncingKeywords} pendentes
          </Typography>
        ))}
      {noResultKeywords > 0 && (
        <Chip
          size="small"
          color="warning"
          variant="outlined"
          label={`${noResultKeywords} sem resultados no Maps`}
          sx={{ height: 22, "& .MuiChip-label": { px: 1, fontSize: 11 } }}
        />
      )}
      {failedKeywords > 0 && (
        <Chip
          size="small"
          color="error"
          variant="outlined"
          label={failedKeywords === 1 ? "1 falha para revisar" : `${failedKeywords} falhas para revisar`}
          sx={{ height: 22, "& .MuiChip-label": { px: 1, fontSize: 11 } }}
        />
      )}
    </Stack>
  );
};
